// extracted by mini-css-extract-plugin
export default {"wrapper":"PaginationComponent_wrapper__U6pLD"};